import { ContainerModule } from 'inversify'
import { UserStore } from 'store/user'
import Types from '../../config/inversify.types'
import { UserServiceImpl } from './user.service.impl'

export const UserModule = new ContainerModule((bind) => {
    bind(Types.UserService).to(UserServiceImpl).inSingletonScope()
    bind(Types.UserStore).to(UserStore).inSingletonScope()
})
